import projectOne from "../assets/project-1.png";
import projectTwo from "../assets/project-2.png";
import projectThree from "../assets/project-3.png";
import projectFour from "../assets/project-4.png";

const projects = {
  1: {
    title: "GC Events Web",
    image: projectOne,
    description: (
      <>
        {/* <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p> */}
      </>
    ),
    github: "https://www.figma.com/design/CCuOzdRg64BJJO01rgVemj/GC-Event?node-id=0-1&t=nj7q3HM2VenIG5MK-0",
    demo: "https://netlify.com",
  },
  2: {
    title: "Travel App",
    image: projectTwo,
    description: (
      <>
        {/* <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p> */}
      </>
    ),
    github: "https://www.figma.com/design/gUhw8odbn6SVvdkaRQlAZH/Travel-App?node-id=0-1&t=pBkMBDj6WFC9mfN3-0",
    demo: "https://netlify.com",
  },
  3: {
    title: "Sample Web Design",
    image: projectThree,
    description: (
      <>
        {/* <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p> */}
      </>
    ),
    github: "https://www.figma.com/design/qWNgdrgUh4TDfPoVAL2hIo/Sample-Designs?node-id=0-1&t=pBkMBDj6WFC9mfN3-0",
    // demo: "https://netlify.com",
  },
  4: {
    title: "Coffee Shop App",
    image: projectFour,
    description: (
      <>
        {/* <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p> */}
      </>
    ),
    github: "https://www.figma.com/design/ThoCjS5ZXs6x2Igjp9YRdB/Coffee-Shop?node-id=0-1&t=zLBfedjX81AdKlTM-0",
    // demo: "https://netlify.com",
  },
  5: {
    title: "Food Delivery App",
    image: projectThree,
    description: (
      <>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>
      </>
    ),
    github: "https://github.com",
    demo: "https://netlify.com",
  },
  6: {
    title: "Food Delivery App",
    image: projectThree,
    description: (
      <>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>
      </>
    ),
    github: "https://github.com",
    demo: "https://netlify.com",
  },
};

export default projects;
